import React, { Component } from 'react';
import Lightbox from 'react-images';

class LightboxImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImageIndex: 0,
      isOpen: false,
    };
  }

  prevImage() {
    this.setState({
      currentImageIndex:
        this.state.currentImageIndex === 0
          ? this.props.images.length - 1
          : this.state.currentImageIndex - 1,
    });
  }

  nextImage() {
    this.setState({
      currentImageIndex:
        (this.state.currentImageIndex + 1) % this.props.images.length,
    });
  }

  open() {
    this.setState({
      isOpen: true,
    });
  }

  close() {
    this.setState({
      isOpen: false,
    });
  }

  render() {
    const images = this.props.images;
    let thumbnail = this.props.thumbnail;
    if (!thumbnail) {
      thumbnail = images[0].src;
    }
    const alt = images[0].caption;
    const currentImageIndex = this.state.currentImageIndex;
    const isOpen = this.state.isOpen;

    return (
      <div>
        <img
          className="a-frontpage-image u-smooth-transitions w-100"
          src={thumbnail}
          alt={alt}
          onClick={() => this.open()}
        />
        <Lightbox
          images={images}
          currentImage={currentImageIndex}
          isOpen={isOpen}
          onClickPrev={() => this.prevImage()}
          onClickNext={() => this.nextImage()}
          onClickImage={e => (document.location = e.target.src)}
          onClose={() => this.close()}
          imageCountSeparator=" av "
        />
      </div>
    );
  }
}

export default LightboxImage;



// WEBPACK FOOTER //
// ./src/components/LightboxImage.js